import { z } from 'zod';

export const baseConnectionLog = z.object({
  documentId: z.string(),
  loggedAt: z.string().nullish(),
  ipAddress: z.string().nullish(),
  client: z.string().nullish(),
});
